import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { parseCss, ruleTypes } from "./parseCss.js";

function transformCss(cssText, transform) {
  var node = parseCss(cssText);

  if (typeof transform === 'function') {
    node = transformNode(node, transform);
  }

  return toCssText(node);
}

function isKeyframesSelector(rule) {
  return rule.parent && rule.parent.type === ruleTypes.keyframes;
}

function toRules(cssText) {
  var node = parseCss(cssText);
  var rules = [];

  if (node.rules && node.rules.length > 0) {
    rules = node.rules.map(function (rule) {
      return toCssText(rule);
    });
  } else {
    var _cssText = toCssText(node);

    if (_cssText) {
      rules = [_cssText];
    }
  }

  return rules;
}

function transformNode(node, transform) {
  if (!node) {
    return;
  }

  if (node.type === ruleTypes.style) {
    return transform(node);
  }

  var rules = node.rules || [];

  var transformed = _objectSpread({}, node);

  transformed.rules = rules.map(function (rule) {
    return transformNode(rule, transform);
  });
  return transformed;
}

function toCssText(node, text) {
  var cssText = '';
  var result = text || '';

  if (node.rules && node.rules.length > 0) {
    cssText = node.rules.map(function (rule) {
      return toCssText(rule, cssText);
    }).join('\n');
  } else {
    cssText = node.cssText.trim();

    if (cssText) {
      cssText = "  ".concat(cssText, "\n");
    }
  }

  if (cssText) {
    var prefix = node.selector ? "".concat(node.selector, " {\n") : '';
    var suffix = node.selector ? '}\n' : '';
    result += "".concat(prefix).concat(cssText).concat(suffix);
  }

  return result;
}

export default transformCss;
export { transformCss, toRules, isKeyframesSelector };